// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#proof-team-comment-add[data-v-26c8543a]{position:relative;background-color:#fff;z-index:2;box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03)}#proof-team-comment-add.static[data-v-26c8543a]{position:static}.gold[data-v-26c8543a]{color:#bf9000}", ""]);
// Exports
module.exports = exports;
